import { Link } from 'react-router-dom';
import { FaPhoneAlt } from 'react-icons/fa';

function CTAButton({ text, to = '/contact', href, scrollTo, className = '', icon = 'arrow' }) {
  const arrowIcon = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden>
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  );

  const phoneIcon = <FaPhoneAlt size={15} aria-hidden />;

  const leadingIcon = icon === 'phone' ? phoneIcon : null;
  const trailingIcon = icon === 'arrow' ? arrowIcon : null;

  const classes = `cta-button ${className}`.trim();

  const content = (
    <>
      {leadingIcon}
      {text}
      {trailingIcon}
    </>
  );

  if (scrollTo) {
    const handleScroll = (e) => {
      e.preventDefault();
      const selector = scrollTo.startsWith('.') || scrollTo.startsWith('#')
        ? scrollTo
        : `.${scrollTo}`;
      const el = document.querySelector(selector);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    return (
      <button type="button" className={classes} onClick={handleScroll}>
        {content}
      </button>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes}>
        {content}
      </a>
    );
  }

  return (
    <Link to={to} className={classes}>
      {content}
    </Link>
  );
}

export default CTAButton;
